import { assign, MachineOptions } from 'xstate'

import {
  QuizEvents,
  QuizMachineContext
} from '@f/applications/QuizApp/stateMachine/initializeQuizMachine'

export const actions: MachineOptions<
  QuizMachineContext,
  QuizEvents
>['actions'] = {
  moveToNextStep: assign({
    displayStep: true,
    currentStepIndex: context => context.currentStepIndex + 1,
    flow: context => ({
      ...context.flow,
      flow_information: {
        ...context.flow.flow_information,
        flow_step: context.flow.flow_information.flow_step + 1
      }
    })
  }),
  moveToPrevStep: assign({
    displayStep: false,
    currentStepIndex: context => context.currentStepIndex - 1,
    flow: context => ({
      ...context.flow,
      flow_information: {
        ...context.flow.flow_information,
        flow_step: context.flow.flow_information.flow_step - 1
      }
    })
  }),
  updateVisitedSteps: assign({
    visitedStepsAmount: context =>
      context.currentStepIndex >= context.visitedStepsAmount
        ? context.visitedStepsAmount + 1
        : context.visitedStepsAmount
  }),
  trackQuestionDisplay: context => {
    window._wt({
      category: 'question',
      action: 'display',
      values: [
        {
          type: 'name',
          value: context.steps[context.currentStepIndex]._wtName
        }
      ],
      ...context.flow
    })
  },
  startLoaderTransition: assign({
    displayLoader: true
  }),
  endLoaderTransition: assign({
    displayLoader: false
  }),
  hideStep: assign({
    displayStep: false
  }),
  showStep: assign({
    displayStep: true
  })
}
